exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Copyright (c) 2018 Scaper */\n.scpr-SetPhoneNumber-form {\n  min-height: 180px; }\n  .scpr-SetPhoneNumber-form .react-phone-number-input select {\n    display: block; }\n", "", {"version":3,"sources":["/Users/promon/Documents/Scaper/workspace/scaper/src/app/auth/src/app/auth/setPhoneNumber.scss"],"names":[],"mappings":"AAAA,+BAA+B;AAE/B;EACI,kBAAiB,EAKpB;EAND;IAIQ,eAAc,EACjB","file":"setPhoneNumber.scss","sourcesContent":["/* Copyright (c) 2018 Scaper */\n\n.scpr-SetPhoneNumber-form {\n    min-height: 180px;\n\n    .react-phone-number-input select {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);

// exports
